import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '../../components/Buttons';

export default class SearchTile extends Component {
    static propTypes = {
        onClick: PropTypes.func,
        option: PropTypes.shape({
            label: PropTypes.string.isRequired,
            value: PropTypes.string.isRequired,
        }),
        title: PropTypes.bool,
        grow: PropTypes.bool,
        selected: PropTypes.bool,
        clickDisable: PropTypes.bool,
        isDisplayTile: PropTypes.bool,
    };

    static defaultProps = {
        selected: false,
        title: false,
    };

    render() {
        let {
            title,
            grow,
            onClick,
            option,
            selected,
            clickDisable,
            isDisplayTile,
        } = this.props

        let color = '#000'
        if (title) {
            color = '#78450b'
        }
        const style = {
            marginRight: 2,
            marginBottom: 2,
            padding: 5,
            borderColor: 'white',
            backgroundColor: selected ? '#F86C00' : 'white',
            cursor: 'pointer',
            color,
            fontWeight: title ? 'bold' : 'inherit',
            fontSize: 14,
            minWidth: title ? 200 : 'inherit',
            flexGrow: grow ? 1 : 0,
            textAlign: title ? 'left' : 'center'
        }

        return (
            <React.Fragment>
                {clickDisable ?
                    <div
                        tabIndex={0}
                        style={{
                            ...style,
                            cursor: 'auto',
                        }}>
                        {this.props.children}
                    </div> :
                    <Button
                        aria-label={option.label.replace(/-/i, 'to')}
                        style={{
                            ...style,
                            display: isDisplayTile? '' : 'none',
                        }}
                        onClick={ () => onClick(option.value)}>
                        {title ?
                            <span style={{textAlign: 'left', width: '100%'}}>{this.props.children}</span> :
                            this.props.children
                        }
                    </Button>}
            </React.Fragment>
        )
    }
}
